export const PATHS = {
  LOGIN: "login",
  DASHBOARD: "inicio",
  DOCUMENTS: {
    OVERVIEW: "documents/overview",
    REPORTS: {
      MONTHLY: "documents/reports/monthly",
      ANNUAL: "documents/reports/annual",
      CATEGORY: {
        CONTRACTS: "documents/reports/category/contracts",
        FINANCIAL: "documents/reports/category/financial"
      }
    }
  },
  SETTINGS: {
    PROFILE: "settings/profile",
    PREFERENCES: "settings/preferences"
  },
  CADASTRO: {
    EMPRESA: "cadastro/empresa",
    PERMISSAO_REGISTRO: "cadastro/permissao-registro",
    TIPO_DOCUMENTO: {
      INCLUIR: "cadastro/tipo-documento/incluir",
      ALTERAR: "cadastro/tipo-documento/alterar",
      EXCLUIR: "cadastro/tipo-documento/excluir",
      MOVER_DOCUMENTOS: "cadastro/tipo-documento/mover-documentos"
    }
  },
  CAIXA: {
    CONSULTAR_DOCUMENTOS: "caixa/consultar-documentos",
    CONSULTAR_HISTORIA: "caixa/consultar-historia",
    CONSULTAR_CAIXAS_ABERTAS: "caixa/consultar-caixas-abertas",
    MOVIMENTAR_DOCUMENTOS: "caixa/movimentar-documentos"
  },
  DOCUMENTOS: {
    LOCALIZAR: {
      LOCALIZAR_POR_TIPO_DOCUMENTO: "documentos/localizar/por-tipo-documento",
      LOCALIZAR_POR_CHAVE: "documentos/localizar/por-chave"
    },
    CADASTRO: {
      INCLUIR: "documentos/cadastro/incluir",
      ALTERAR: "documentos/cadastro/alterar",
      EXCLUIR: "documentos/cadastro/excluir"
    },
    EMPRESTIMO: {
      REALIZAR: "documentos/emprestimo/realizar",
      REALIZAR_DEVOLUCAO: "documentos/emprestimo/realizar-devolucao",
      // Fase 9: Excluir Empréstimo foi mesclado nesta tela (4º Modo) — não existe mais rota própria.
      ALTERAR: "documentos/emprestimo/alterar"
    }
  },
  EXPURGO: {
    NOVO_LOTE: "expurgo/novo-lote",
    EXPURGAR_CANCELAR_LOTE: "expurgo/expurgar-cancelar-lote",
    TERMO_EXPURGO: "expurgo/termo-expurgo",
    RELATORIO_EXPIRACAO_DOCUMENTOS: "expurgo/relatorio-expiracao-documentos"
  }
} as const;
